<vex-page-layout>
    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.px-gutter]="true" class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Busqueda y Reportes</h1>
                <vex-breadcrumbs [crumbs]="crumbs"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content [class.px-gutter]="true" class="-mt-6">
        <div class="card overflow-auto -mt-16">
            <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
                <span class="flex-1"></span>
                <button mat-icon-button type="button" matTooltip="Exportar a Excel"
                    (click)="exporter.exportTable('xlsx', {fileName: 'desaparecidos_report'})">
                    <mat-icon class="text-secondary" svgIcon="mat:file_copy"></mat-icon>
                </button>
                <button mat-icon-button type="button" matTooltip="Exportar a CSV"
                    (click)="exporter.exportTable('csv', {fileName: 'desaparecidos_report'})">
                    <mat-icon class="text-secondary" svgIcon="mat:import_export"></mat-icon>
                </button>
            </div>

            <div class="mr-5 ml-5 mt-5">
                <form (ngSubmit)="filter()" [formGroup]="formSearch" novalidate>
                    <mat-form-field class="ml-2">
                        <mat-label>Fecha desde</mat-label>
                        <input formControlName="desde" (click)="formDatepickerRef.open()"
                            (focus)="formDatepickerRef.open()" [matDatepicker]="formDatepickerRef" matInput readonly>
                        <mat-datepicker-toggle [for]="formDatepickerRef" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #formDatepickerRef></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="ml-2">
                        <mat-label>Fecha hasta</mat-label>
                        <input formControlName="hasta" (click)="datePickerHastaRef.open()"
                            (focus)="datePickerHastaRef.open()" [matDatepicker]="datePickerHastaRef" matInput readonly>
                        <mat-datepicker-toggle [for]="datePickerHastaRef" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #datePickerHastaRef></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="ml-2">
                        <mat-label>Documento</mat-label>
                        <input matInput formControlName="documento">
                    </mat-form-field>
                    <mat-form-field class="ml-2">
                        <mat-label>Complemento</mat-label>
                        <input matInput formControlName="complemento">
                    </mat-form-field>
                    <mat-form-field class="ml-2">
                        <mat-label>Nombres</mat-label>
                        <input matInput formControlName="nombres">
                    </mat-form-field>
                    <mat-form-field class="ml-2">
                        <mat-label>Paterno</mat-label>
                        <input matInput formControlName="paterno">
                    </mat-form-field>
                    <mat-form-field class="ml-2">
                        <mat-label>Materno</mat-label>
                        <input matInput formControlName="materno">
                    </mat-form-field>
                    <mat-form-field class="ml-2">
                        <mat-label>Estado</mat-label>
                        <mat-select formControlName="encontrado">
                            <mat-option [value]="true">Encontrado</mat-option>
                            <mat-option [value]="false">No encontrado</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button class="ml-3" color="primary" mat-mini-fab type="submit"> <mat-icon class="text-white"
                            svgIcon="mat:search"></mat-icon></button>
                    <button class="ml-3" color="warn" mat-mini-fab (click)="exportPdf()" type="menu"> <mat-icon
                            class="text-white" svgIcon="mat:picture_as_pdf"></mat-icon></button>
                    <button class="ml-3" color="accent" mat-mini-fab (click)="clear()" type="reset"> <mat-icon
                            class="text-white" svgIcon="mat:clear"></mat-icon></button>
                </form>
            </div>

           
            <table [dataSource]="dataSource" class="w-full" mat-table matSort matTableExporter
                #exporter="matTableExporter" id="datasourceTable">
                <ng-container matColumnDef="id">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Identificador</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.id }}</td>
                </ng-container>
                <ng-container matColumnDef="apellido_paterno">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Paterno</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.apellido_paterno }}</td>
                </ng-container>
                <ng-container matColumnDef="apellido_materno">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Materno</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.apellido_materno }}</td>
                </ng-container>
                <ng-container matColumnDef="nombres">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Nombres</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.nombres }}</td>
                </ng-container>
                <ng-container matColumnDef="documento">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Documento</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.documento }}</td>
                </ng-container>
                <ng-container matColumnDef="gestion">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Gestion</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.gestion }}</td>
                </ng-container>
                <ng-container matColumnDef="color_ojos">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Color ojos</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.color_ojos }}</td>
                </ng-container>
                <ng-container matColumnDef="color_cabellos">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Color cabellos</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.color_cabellos }}</td>
                </ng-container>
                <ng-container matColumnDef="sexo">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Sexo</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.sexo }}</td>
                </ng-container>
                <ng-container matColumnDef="nacionalidad">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Nacionalidad</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.nacionalidad }}</td>
                </ng-container>
                <ng-container matColumnDef="fecha_nacimiento">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha nacimiento</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.fecha_nacimiento | date:'dd/MM/yyyy' }}</td>
                </ng-container>
                <ng-container matColumnDef="fecha_desaparicion">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha desaparicion</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.fecha_desaparicion | date:'dd/MM/yyyy HH:mm' }}</td>
                </ng-container>
                <ng-container matColumnDef="peso">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Peso</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.peso }}</td>
                </ng-container>
                <ng-container matColumnDef="tez">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Tez</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.tez }}</td>
                </ng-container>
                <ng-container matColumnDef="estatura">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Estatura</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.estatura }}</td>
                </ng-container>
                <ng-container matColumnDef="vestimenta">
                    <th *matHeaderCellDef mat-header-cell>Vestimenta</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.vestimenta }}</td>
                </ng-container>
                <ng-container matColumnDef="resumen">
                    <th *matHeaderCellDef mat-header-cell>Resumen</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.resumen }}</td>
                </ng-container>
                <ng-container matColumnDef="lugar_hecho">
                    <th *matHeaderCellDef mat-header-cell>Lugar hecho</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.lugar_hecho }}</td>
                </ng-container>
                <ng-container matColumnDef="encontrado">
                    <th *matHeaderCellDef mat-header-cell>Encontrado</th>
                    <td *matCellDef="let element" mat-cell>
                        <div (click)="$event.stopPropagation()" class="flex items-center gap-1">
                            <div [ngClass]="element.encontrado? [stateConstant.SUCCESS_TEXT_CLASS, stateConstant.SUCCESS_BG_CLASS]: [stateConstant.ERROR_TEXT_CLASS, stateConstant.ERROR_BG_CLASS]"
                                class="rounded px-2 py-1 font-medium text-xs flex-none">
                                {{element.encontrado?'Si':'No'}}
                            </div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="latitud">
                    <th *matHeaderCellDef mat-header-cell>Latitud</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.latitud }}</td>
                </ng-container>
                <ng-container matColumnDef="longitud">
                    <th *matHeaderCellDef mat-header-cell>Longitud</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.longitud }}</td>
                </ng-container>
                <ng-container matColumnDef="url_thumbnail">
                    <th *matHeaderCellDef mat-header-cell>Thumbnail</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.url_thumbnail }}</td>
                </ng-container>
                <ng-container matColumnDef="url_photo">
                    <th *matHeaderCellDef mat-header-cell>Foto</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.url_photo }}</td>
                </ng-container>
                <ng-container matColumnDef="url_pdf_report">
                    <th *matHeaderCellDef mat-header-cell>Pdf report</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.url_pdf_report }}</td>
                </ng-container>
                <ng-container matColumnDef="url_pdf_image_report">
                    <th *matHeaderCellDef mat-header-cell>Image report</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.url_pdf_image_report }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="edad">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Edad</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.edad }}</td>
                </ng-container>
                <ng-container matColumnDef="referencia">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Referencia</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.referencia }}</td>
                </ng-container>
                <ng-container matColumnDef="departamento">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Departamento</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.departamento }}</td>
                </ng-container>
                <ng-container matColumnDef="provincia">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Provincia</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.provincia }}</td>
                </ng-container>
                <ng-container matColumnDef="municipio">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Municipio</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.municipio }}</td>
                </ng-container>
                <ng-container matColumnDef="fecha_registro">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA fecha registro</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.fecha_registro }}</td>
                </ng-container>
                <ng-container matColumnDef="hora_registro">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA hora registro</th>
                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.hora_registro }}</td>
                </ng-container>
                
                    <ng-container matColumnDef="lugar_remision">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA lugar remision</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.lugar_remision }}</td>
                    </ng-container>
                    <ng-container matColumnDef="responsable_seguimiento">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA responsable</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.responsable_seguimiento }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="atencion">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA atencion</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.atencion }}</td>
                    </ng-container>
                    <ng-container matColumnDef="albergue">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA albergue</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.albergue }}</td>
                    </ng-container>
                    <ng-container matColumnDef="derivacion">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA derivacion</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.derivacion }}</td>
                    </ng-container>
                    <ng-container matColumnDef="entrega">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>DNA entrega</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.entrega }}</td>
                    </ng-container>
                
                
                    <ng-container matColumnDef="atencion_fecha">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>SALUD fecha atencion</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.atencion_fecha }}</td>
                    </ng-container>
                    <ng-container matColumnDef="atencion_hora">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>SALUD hora atencion</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.atencion_hora }}</td>
                    </ng-container>
                    <ng-container matColumnDef="atencion_centro">
                        <th *matHeaderCellDef mat-header-cell mat-sort-header>SALUD centro atencion</th>
                        <td *matCellDef="let element" class="text-secondary" mat-cell>{{ element.atencion_centro }}</td>
                    </ng-container>
                

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            

            


            <mat-paginator [pageSizeOptions]="appSettings.PAGE_SIZE_OPTIONS" [pageSize]="appSettings.PAGE_SIZE"
                class="sticky left-0"></mat-paginator>
        </div>
    </vex-page-layout-content>
</vex-page-layout>